<template>
    <div>
        <div class="px-2 py-3">
            <BasicInfo
                class="block-item bg-grey2 p-3"
                :provinceOpt="provinceOpt"
                @file-uploaded = "fileUploaded"
                ref="basicInfo"
            ></BasicInfo>
        
            <LegalInfo
                class="block-item bg-grey2 p-3"
                :provinceOpt="provinceOpt"
                :doc_type_list = document
                :nationalityOpt="nationalityOpt"
                @file-uploaded = "fileUploaded"
                ref="legalInfo"
            ></LegalInfo>

            <RegisterInfo
                class="block-item bg-grey2 p-3"
                :provinceOpt="provinceOpt"
                :nationalityOpt="nationalityOpt"
                @file-uploaded = "fileUploaded"
                ref="registerInfo"
            ></RegisterInfo>
        

            <div class="mb-4 block-item bg-grey2 p-3">
                <div class="d-flex">
                    <h5>{{ $t('Beneficiary Information') }}</h5>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup()">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="'beneficiary'" v-if="showPopup"></NewPopupInfo>
                    </span>
                </div>
                
                <div class="px-0 mb-3 mt-3">
                    <div v-for="(item,index) in beneficary_list" :key="item.id">
                        
                        <BeneficiaryInfo 
                            :doc_type_list = document
                            :nationalityOpt = "nationalityOpt"
                            :provinceOpt = "provinceOpt"
                            :is_remove = "beneficary_list.length>1?true:false"
                            :ref="'beneficiary'+item.id"
                            @file-uploaded = "fileUploaded"
                        ></BeneficiaryInfo>
                        <hr>
                        <div class="d-flex justify-content-end mb-2">
                            <div class="mb-0">
                                
                                <div class="w-100 ml-auto d-flex justify-content-end mb-3">
                                    <button v-if="beneficary_list.length>1" class="d-flex align-items-center btn btn-outline-red" @click="removeItem(item.id)">
                                        <span>Remove</span>
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                    <button class="btn btn-outline-orange" @click="addBeneficiary">Add +</button>
                                </div>

                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <hr>
            <div  class="form-group text-justify">
                <label :for="agree" id="agree" class="d-flex align-items-start justify-content-center">
                    <input v-model="agree" type="checkbox" autocomplete="off" @change="onChange('agree')" class="mt-2">
                    <span class="ml-4 w-100 fz-14">
                        <p><i>{{ $t('agreement-1') }}</i></p>
                        <p><i>{{ $t('agreement-2') }}</i></p>
                        <p><i>{{ $t('agreement-3') }}</i></p>
                    </span>
                </label>
                <div v-if="error.agree" class="text-danger d-block">
                    {{$t(error.agree)}}
                </div>
            </div>
            
            <TakePicture :ref="'take-picture'" @take-photo="takePhoto($event)"></TakePicture>
        </div>
        <div class="text-right mt-3">
            <button class="btn btn-primary" @click="submitAccount">Submit</button>
        </div>

        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>

    import Select2 from 'v-select2-component';

    import FileUploader from '@/components/Kyc/FileUploader.vue';
    import TakePicture from "@/components/Kyc/TakePicture";
    import NewDocOption from "@/components/Kyc/NewDocOption";
    import BeneficiaryInfo from '@/components/CardManagement/beneficiaryInfo.vue';
    import BasicInfo from '@/components/CardManagement/basicInfo.vue';
    import LegalInfo from '@/components/CardManagement/legalInfo.vue';
    import RegisterInfo from '@/components/CardManagement/RegisterInfo.vue';

    import CreateAccount from '@/services/CreateAccount';
    import LoaderComponent from "@/components/LoaderComponent";
    import NewPopupInfo from '@/components/NewPopupInfo.vue';

    import Vue from 'vue';

    export default {
        name: 'enterprises-china',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                nationality:'',
                showPopup:false,
                agree:'',
                provinceOpt:[],
                nationalityOpt:[],
                beneficary_list:[{"id":1}],
                isDisabled:false,
                isLoading:false,
                basic_info:{},
                legal_info:{},
                register_info:{},
                account:{},
                beneficary_data:[],
                legal_personal_doc_type:0,
                document:[
                    {
                        "id":1,
                        "name":"Identity Card"
                    },
                    {
                        "id":2,
                        "name":"Passport"
                    }
                ],
                error:{
                    nationality:'',
                    agree:''
                }
            }
        },
        components: {
            TakePicture,
            FileUploader,
            LoaderComponent,
            Select2,
            NewDocOption,
            BeneficiaryInfo,
            BasicInfo,
            LegalInfo,
            RegisterInfo,
            NewPopupInfo
        },
        methods:{
            onChange(name){
                this.error[name]="";
            },
            submitAccount(){
                let is_valid = true;
                let self = this;
                this.isLoading = true;

                if(!this.$refs['basicInfo'].validate()){
                    console.log("basic info belum valid");
                    is_valid = false;
                }

                if(!this.$refs['legalInfo'].validate()){
                    console.log("legal info belum valid");
                    is_valid = false;
                }

                if(!this.$refs['registerInfo'].validate()){
                    console.log("register info belum valid");
                    is_valid = false;
                }

                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    if(!this.$refs[ref][0].validate()){
                        console.log("beneficiary belum valid");
                        is_valid = false;
                    }
                }

                if(!this.agree){
                    is_valid = false;
                    console.log("agree belum valid");
                    this.error.agree = "must be checked";
                }

                if(is_valid){
                    CreateAccount.createType({"userType":2}).then(response => {
                        const data = response.data.data;
                        self.uploadPhoto(data);
                    }).catch(err => {
                        this.checkError(err);
                    });
                }
                else{
                    this.isLoading = false;
                }
            },
            uploadPhoto(account){
                console.log("=== account ===");
                console.log(account);
                this.account = account;
                this.$refs['basicInfo'].uploadFile(account);
                this.$refs['legalInfo'].uploadFile(account);
                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    this.$refs[ref][0].uploadFile(account);
                }
            },
            fileUploaded(){
                let beneficiary_completed = true;
                let have_failed = false;
                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    if(this.$refs[ref][0].success==null){
                        beneficiary_completed = false;
                    }
                    if(this.$refs[ref][0].success === false){
                        have_failed = true;
                    }
                }

                if(
                    this.$refs['basicInfo'].success!=null &&
                    this.$refs['legalInfo'].success!=null &&
                    beneficiary_completed
                ){
                    if(
                        this.$refs['basicInfo'].success === false ||
                        this.$refs['legalInfo'].success === false ||
                        have_failed === true
                    ){
                        this.isLoading = false;
                    }
                    else if(
                        this.$refs['basicInfo'].success === true &&
                        this.$refs['legalInfo'].success === true &&
                        have_failed === false
                    ){
                        this.submitData();
                    }
                }
            },
            submitData(){

                let basic_info = this.$refs['basicInfo'];
                let legal_info = this.$refs['legalInfo'];
                let register_info = this.$refs['registerInfo'];

                let params = {
                    "accountId":this.account.accountId,
                    "license":""+basic_info.file.license,
                    "licenseNo":basic_info.params.licenseNo,
                    "name":basic_info.params.name,
                    "enName":basic_info.params.enName,
                    "endDate":basic_info.params.endDate,
                    "province":basic_info.params.province_code,
                    "city":basic_info.params.city_code,
                    "area":basic_info.params.district_code,
                    "address":basic_info.params.address,
                    "companyType" : basic_info.params.companyType,
                    "managementScope" : basic_info.params.managementScope,
                    "legalName" : legal_info.params.legalName,
                    "legalIdType" : legal_info.params.legalIdType,
                    "legalIdFront": legal_info.file.legalIdFront,
                    "legalIdReverse": legal_info.file.legalIdReverse,
                    "legalIdHold": legal_info.file.legalIdHold,
                    "legalRepresentative" :  legal_info.params.legalRepresentative,
                    "legalCountryCode" : "CHN",
                    "legalProvince" : legal_info.params.legalProvince,
                    "legalCity" : legal_info.params.legalCity,
                    "legalArea" : legal_info.params.legalArea,
                    "legalAddress" : legal_info.params.legalAddress,
                    "legalCertExpiryDate" : legal_info.params.legalCertExpiryDate,
                    "legalBirthDate" : legal_info.params.legalBirthDate,
                    "legalIdNo" : legal_info.params.legalIdNo,
                    "registerDate":register_info.params.registerDate,
                    "registerAmt" : register_info.params.registerAmt,
                    "registerProvince" : register_info.params.registerProvince,
                    "registerCity" : register_info.params.registerCity,
                    "registerArea" : register_info.params.registerArea,
                    "registerAddress" : register_info.params.registerAddress,
                    "registerCcy" : "CNY",
                    "beneficiaryIdFront":[],
                    "beneficiaryIdReverse":[],
                    "beneficiaryIdHold":[],
                    "beneficiaryIdType":[],
                    "beneficiaryIdNo":[],
                    "beneficiaryName":[],
                    "beneficiaryBirthDate":[],
                    "beneficiaryCertExpiryDate":[],
                    "beneficiaryCountry":[],
                    "beneficiaryProvince":[],
                    "beneficiaryCity":[],
                    "beneficiaryArea":[],
                    "beneficiaryAddress":[],
                    "beneficiaryShareholderRatio":[],
                };

                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    params['beneficiaryIdFront'].push(this.$refs[ref][0].file.beneficiaryIdFront);
                    params['beneficiaryIdReverse'].push(this.$refs[ref][0].file.beneficiaryIdReverse);
                    params['beneficiaryIdHold'].push(this.$refs[ref][0].file.beneficiaryIdHold);
                    params['beneficiaryIdType'].push(this.$refs[ref][0].params.beneficiaryIdType);
                    params['beneficiaryIdNo'].push(this.$refs[ref][0].params.beneficiaryIdNo);
                    params['beneficiaryName'].push(this.$refs[ref][0].params.beneficiaryName);
                    params['beneficiaryBirthDate'].push(this.$refs[ref][0].params.beneficiaryBirthDate);
                    params['beneficiaryCertExpiryDate'].push(this.$refs[ref][0].params.beneficiaryCertExpiryDate);
                    params['beneficiaryCountry'].push("CHN");
                    params['beneficiaryProvince'].push(this.$refs[ref][0].params.beneficiaryProvince);
                    params['beneficiaryCity'].push(this.$refs[ref][0].params.beneficiaryCity);
                    params['beneficiaryArea'].push(this.$refs[ref][0].params.beneficiaryArea);
                    params['beneficiaryAddress'].push(this.$refs[ref][0].params.beneficiaryAddress);
                    params['beneficiaryShareholderRatio'].push(this.$refs[ref][0].params.beneficiaryShareholderRatio);
                }

                console.log("=== parameter ===");
                console.log(params);

                CreateAccount.domestic(params).then(response => {
                    const data = response.data.data;
                    this.isLoading = false;
                    this.$swal({
                        icon: 'success',
                        title: 'success',
                        showConfirmButton: true,
                    }).then((result) => {
                        this.$router.push({ path: '/list-account' });
                    });
                }).catch(err => {
                    this.checkError(err);
                });

            },
            togglePopup(){
                this.showPopup=!this.showPopup;
            },
            addBeneficiary(){
                this.beneficary_list.push({"id":(this.beneficary_list[this.beneficary_list.length-1].id+1)});
            },
            selectedDocument(data){
                this.legal_personal_doc_type = data.index;
            },
            removeItem(id) {
                const index = this.beneficary_list.findIndex(item => item.id === id)
                if (index !== -1) {
                    this.beneficary_list.splice(index, 1)
                }
            },
            removeImage($event){
                console.log($event);
            },
            captureFile($event) {
                console.log($event);
            },
            toggleCamera(current_take) {
                this.current_take = current_take;
                this.$refs['take-picture'].toggleCamera(current_take);
            },
            takePhoto($event){
               console.log($event);
            },
            getMessage: function (key) {
                return this.$t(key)
            },
            checkError(err){
                let self = this;
                try{
                    this.isLoading = false;
                    const response = err.response;  
                    if(response.status == 400){
                        console.log(response.data);
                        if(typeof response.data.message === 'string'){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message,
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            if(response.data.message['errorMsg']){
                                this.$swal({
                                    icon: 'info',
                                    html:response.data.message['errorMsg'],
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                            else{
                                let ret = [];
                                let basic_info = this.$refs['basicInfo'];
                                let legal_info = this.$refs['legalInfo'];
                                let register_info = this.$refs['registerInfo'];

                                Object.keys(response.data.message).forEach((key) => {
                                    let error = response.data.message[key][0];
                                    
                                    if(typeof basic_info.error[key] !== "undefined"){
                                        basic_info.error[key] = error;
                                    }
                                    else if(typeof legal_info.error[key] !== "undefined"){
                                        legal_info.error[key] = error;
                                    }
                                    else if(typeof register_info.error[key] !== "undefined"){
                                        register_info.error[key] = error;
                                    }
                                    
                                    if(key!="accountId"){
                                        ret.push(error);
                                    }
                                });

                                this.$swal({
                                    icon: 'info',
                                    html:ret.join("<br>"),
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                        }
                    }      
                    else if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                                path: '/login', 
                            });
                    }
                    else{
                        if(localStorage.getItem("token")){
                            var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                                type: 'warn',
                                text: msg
                            })
                        }
                    }
                }catch(e){
                    console.log(err);
                }
            }
        },
        mounted(){
            CreateAccount.getProvince({"country":"CHN"}).then(response => {
                const data = response.data.data;
                this.provinceOpt = [];
                data.forEach(item => {
                    this.provinceOpt.push({"id":item.value,"text":item.text,"code":item.id});    
                });
            }).catch(err => {
                this.checkError(err);
            });
        }
    };
  </script>
